export enum PriceListItemType {
    Default = 0,
    Fee = 1,
    PerBedAndNight = 2,
    PerRoomAndNight = 3,
}